<!--
 * @Date: 2020-08-26 15:44:01
 * @Author: MX
 * @LastEditTime: 2023-08-29 14:25:04
 * @Description: 登录
-->
<template>
  <div class="login">
    <div class="login-box">
      <div class="iconBox">
        <i class="iconfont iconjitulogo_fanbai" v-if="$i18n.locale === 'zh-cn'"></i>
        <i class="iconfont icona-JTexpress" v-else></i>
      </div>
      <div class="title">
        {{$t('极兔开放平台')}}
      </div>
      <div class="form">
        <el-form
          ref="loginForm"
          :model="loginForm"
          :rules="rules"
          autocomplete="off"
          class="login-form"
        >
          <el-form-item prop="account">
            <el-input
              :placeholder="$lang('请输入账号或手机号')"
              v-model.trim="loginForm.account"
            >
              <i
                slot="prefix"
                class="iconfont icondengluzhuce_yonghuming"
                :class="loginForm.account && 'red_color'"
              ></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              :placeholder="$lang('请输入密码')"
              :type="isShowPassword ? 'text' : 'password'"
              maxlength="18"
              v-model.trim="loginForm.password"
            >
              <i
                slot="prefix"
                class="iconfont icondengluzhuce_mima"
                :class="loginForm.password && 'red_color'"
              ></i>
              <i
                slot="suffix"
                class="iconfont pointer"
                :class="[
                  isShowPassword
                    ? 'icondenglu_ico_mimakeshi'
                    : 'icondenglu_ico_mimayincang',
                ]"
                @click="toggleIcon"
              ></i>
            </el-input>
          </el-form-item>
          <div class="remember">
            <el-checkbox
              v-model="remember"
              :label="$lang('记住账号')"
              class="remember-account"
            ></el-checkbox>
          </div>
          <el-button
            class="commonBtn loginBtn"
            :disabled="!loginForm.account || !loginForm.password"
            @click.prevent="loginClick"
            :loading="loginLoading"
            >{{$lang("登 录")}}</el-button
          >
          <div class="register-forget">
            <span class="register pointer" @click="goRegister">{{$lang("注册用户")}}</span>
            <span class="forget pointer" @click="forgetPassword">{{$lang("忘记密码")}}</span>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import * as Api from '@/api'
import { RULES } from '@/constants/rules'
import { RESPONSE_SUCCESS } from '@/constants'
import { mapActions } from 'vuex'
// import '@/assets/js/TCaptcha'
import { AESUtil } from '@/utils/'
export default {
  name: 'Login',
  props: {},
  components: {},
  data() {
    return {
      loginForm: {
        account: '',
        password: '',
      },
      loginLoading: false,
      remember: false,
      rules: {
        account: [RULES.account],
        password: [RULES.password, RULES.checkPassword],
      },
      isShowPassword: false, //不显示
      captcha: ''
    }
  },
  computed: {
    lang() {
      return this.$store.state.base.lang
    }
  },
  created() {
    this.init()
    this.initTencentCaptcha()
  },
  mounted(){
  },
  methods: {
    ...mapActions(['LOGIN_INIT']),
    toggleIcon() {
      this.isShowPassword = !this.isShowPassword
      console.log(this.isShowPassword)
    },
    init() {
      // 在页面加载时从cookie获取登录信息
      const account = this.getCookie('account')
      const prd1 = this.getCookie('prd1')
      const prd2 = this.getCookie('prd2')
      const prd3 = this.getCookie('prd3')
      const password = prd1.substring(0, 3) + prd2.substring(0, 3) + prd3

      // 如果存在赋值给表单，并且将记住密码勾选
      if (account) {
        this.loginForm.account = account
        this.loginForm.password = password
        this.remember = true
      }
    },
    
    // 初始化tx验证码
    initTencentCaptcha() {
      // 生成实例对象
      this.captcha = this.$Captcha.init(
        this.tencentCaptchaCallback,
        {forceLang: this.lang === 'CN' ? 'zh-cn' : 'en'}
      );
    },
    // 验证码回调
    async tencentCaptchaCallback(res) {
      console.log("腾讯验证码回调：callback", res);
      // 验证成功，返回对象
      if (res.ret === 0) {
        // 定义参数：票据 随机字符串
        const customParams = {
          ticket: res.ticket,
          randstr: res.randstr,
        };
        // 调用登陆
        this.loginApi(customParams);

        return res;
      }
      // 验证不成功
      return null;
    },

    loginClick(){
      this.login()
    },
    /**
     * @description 登录
     */
    async login() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loginLoading = true
          this.captcha.show()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async loginApi(customParams) {
      const { account, password } = this.loginForm;
      Api.login({account, password: AESUtil.aesEncrypt(password), ...customParams}).then((res) => {
        this.loginLoading = true
        if (res.code === RESPONSE_SUCCESS) {
          // this.loginLoading = false
          this.LOGIN_INIT({ user: res.data, token: res.data.token })
          this.$router.push({ path: '/' })

          // 保存用户账号信息到cookie
          this.saveAccountCookie() // 记住密码
        } else {
          this.loginLoading = false
          this.$message.error(res.msg)
          localStorage.setItem('YL_TOKEN', '')
        }
      }).catch(()=>{
        this.loginLoading = false
      })
    },
    /**
     * @description 保存用户名密码
     */
    saveAccountCookie() {
      // 判断用户是否勾选记住密码，如果勾选，向cookie中储存登录信息，
      // 如果没有勾选，储存的信息为空
      const { account, password } = this.loginForm
      if (this.remember) {
        // if (this.getCookie('password') === password) return
        let num1 = '';
        let num2 = '';
        for (var i = 0;i < 5;i++) {
          num1 += Math.floor(Math.random() * 10);
          num2 += Math.floor(Math.random() * 10);
        }
        const prd1 = password.length >= 3 ? (password.substring(0, 3) + num1) : password.substring(0, 3)
        const prd2 = password.length >= 6 ? (password.substring(3, 6) + num2) : password.substring(3, 6)
        const prd3 = password.substring(6)
        this.setCookie('account', account, 7 * 24 * 3600)
        this.setCookie('prd1', prd1, 7 * 24 * 3600)
        this.setCookie('prd2', prd2, 7 * 24 * 3600)
        this.setCookie('prd3', prd3, 7 * 24 * 3600)
      } else {
        this.setCookie('account', '')
        this.setCookie('prd1', '')
        this.setCookie('prd2', '')
        this.setCookie('prd3', '')
      }
    },
    // 获取cookie
    getCookie(key) {
      const cookie = document.cookie
      const length = cookie.length
      if (length) {
        let start = cookie.indexOf(key + '=')
        if (start !== -1) {
          start = start + key.length + 1
          let end = cookie.indexOf(';', start)
          if (end === -1) end = length
          return unescape(cookie.substring(start, end))
        }
      }
      return ''
    },
    // 保存cookie
    setCookie(cName, value, expireseconds) {
      const exdate = new Date()
      exdate.setTime(exdate.getTime() + expireseconds * 1000)
      document.cookie =
        cName +
        '=' +
        decodeURIComponent(value) +
        (expireseconds == null ? '' : ';expires=' + exdate.toGMTString())
    },
    forgetPassword() {
      this.$router.push({ path: '/forgetPassword' })
    },
    goRegister() {
      this.$router.push({ path: '/register' })
    },
  },
}
</script>

<style lang="scss" scoped>
.login {
  height: 100%;
  background: $theme-color url('../../assets/images/register/background.png')
    no-repeat 80px center;
  background-size: 53%;
  position: relative;
  font-family: PingFang, PingFang-SC;
  .login-box {
    position: absolute;
    top: 50%;
    right: 160px;
    width: 520px;
    height: 496px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
    padding: 50px 100px 0px;
    box-sizing: border-box;
    transform: translateY(-50%);
    .iconBox {
      text-align: center;
      .iconfont {
        font-size: 31px;
        line-height: 31px;
        color: $theme-color;
      }
    }
    .title {
      font-size: 20px;
      text-align: center;
      color: $theme-color;
      line-height: 20px;
      margin-top: 40px;
      font-weight: 600;
      user-select: none;
    }
    .form {
      margin-top: 30px;
      .iconfont {
        font-size: 20px;
      }
      .icondengluzhuce_yonghuming,
      .icondengluzhuce_mima {
        &.red_color {
          color: $theme-color;
        }
      }
      .loginBtn {
        width: 320px;
        height: 54px;
        background: $theme-color;
        border-color: $theme-color;
        color: #fff;
        font-size: 18px;
      }
      .remember {
        margin-bottom: 30px;
        .remember-account {
          line-height: 18px;
        }
      }
      .register-forget {
        font-size: 14px;
        color: $theme-color;
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
      }
    }
  }
}
.login::v-deep {
  .el-form-item {
    margin-bottom: 20px;
  }
  .el-form-item__content {
    height: 50px;
    line-height: 50px;
    .el-input__inner {
      height: 50px;
      line-height: 50px;
    }
  }
  .el-checkbox__label{
    padding-right: 10px;
  }
  .el-input__prefix {
    left: 10px;
  }
  .el-input:focus-within .iconfont {
    color: $theme-color;
  }

  .el-input--prefix .el-input__inner {
    padding-left: 40px;
  }
  .el-input--suffix .el-input__inner {
    padding-right: 40px;
  }
  .el-input__suffix {
    right: 10px;
  }
}

[dir="rtl"] .login ::v-deep {
  background-position: right 80px center;
  .login-box{
    right: inherit;
    left: 160px;
  }
  .el-input__prefix {
    left: inherit;
    right: 10px;
  }
  .el-input--prefix .el-input__inner {
    // padding-left: 40px;
    padding-right: 40px;
  }
  .el-input--suffix .el-input__inner {
    // padding-right: 40px;
    padding-left: 10px;
  }
  .el-input__suffix {
    right: initial;
    left: 10px;
  }

}
html.zh-cn  .login .title{
  
      letter-spacing: 40px;
      margin-right: -40px;
}
</style>
